import type { Profile, ProgramContentObject } from 'models';
import { isContentObjectAuthorProfile } from './content-object';
import { isProgramAdminProfile, isProgramAuthorProfile } from './user-roles';
import { isOrganizationAdminProfile, isSuperAdmin } from './utils';

export const canRateProgramObject = ({
  contentObject,
  viewer,
}: {
  contentObject: ProgramContentObject;
  viewer: Profile;
}) => {
  const { organization, program } = contentObject;

  return Boolean(
    program.id &&
    !isSuperAdmin({ viewer }) &&
    !isProgramAdminProfile({ programId: program.id, viewer }) &&
    !isProgramAuthorProfile({ programId: program.id, viewer }) &&
    !isContentObjectAuthorProfile({ contentObject, viewer }) &&
    !isOrganizationAdminProfile({ organizationId: organization.id, viewer }),
  );
};
